<template lang="pug">
  div.form
    header#header
      div.inner
        div.logo
          img(:src="setLogo()")
    main#main
      div(v-if="type === 'c'")
        FormInput(v-if="flow === 'input'",:frm="form",@change="change",@confirm="conf")
        FormConf(v-if="flow === 'confirm'",:form="form",@complete="comp",@back="backInput")
      div(v-if="type === 'b'")
        FormBInput(v-if="flow === 'input'",:frm="form",@change="change",@confirm="conf")
        FormBConf(v-if="flow === 'confirm'",:form="form",@complete="comp",@back="backInput")
      FormComplete(v-if="flow === 'complete'")
</template>

<script>
// import store from '../../stores';
// import axios from 'axios';
import FormInput from './Form.vue';
import FormConf from './Confirm.vue';
import FormComplete from './Complete.vue';
import FormBInput from './FormB.vue';
import FormBConf from './ConfirmB.vue';
// import { Core as YubinBangoCore } from 'yubinbango-core2';
export default {
  name: 'Form',
  components: {
    FormInput,
    FormConf,
    FormBInput,
    FormBConf,
    FormComplete
  },
  data () {
    return {
      form: {},
      flow: 'input'
    };
  },
  computed: {
    forms () {
      return this.$store.getters.forms;
    },
    year () {
      let d = new Date();
      return d.getFullYear();
    },
    type () {
      return this.config.type;
    }
  },
  watch: {
  },
  methods: {
    change (frm) {
      this.form = frm;
    },
    conf (frm) {
      this.form = frm;
      this.flow = 'confirm';
      this.scrollTop();
    },
    comp () {
      this.flow = 'complete';
      this.scrollTop();
    },
    backInput () {
      this.flow = 'input';
      this.scrollTop();
    },
    scrollTop: function () {
      document.querySelector('#main').scrollTo({
        top: 0
      });
    },
    setLogo () {
      if (this.loginUser.company_code !== undefined) {
        let company = this.loginUser.company_code;
        return './static/img/' + company + '.png?rnd=' + Math.round(Math.random() * 1000000);
      } else {
        return this.config.logo;
      }
    }
  },
  created () {
    // let d = new Date();
    // this.selected_month = d.getMonth() + 1;
    // this.selected_day = d.getDate();
  }
};
</script>

<style lang="stylus" scoped>
.form
  background-color #ffffff
  position fixed
  z-index 10000
  left 0
  top 0
  width 100%
  height 100%
#header
  height 77px
  border-bottom 1px solid #DDDDDD
  .inner
    max-width 1040px
    padding 0 20px
    margin 0 auto
    .logo
      padding-top 22px
      img
        height 35px
#main
  position absolute
  left 0
  right 0
  top 78px
  bottom 0
  overflow auto
  .inner
    max-width 1040px
    padding 50px 20px
    margin 0 auto
  h2
    text-align center
    font-size 22px
    margin-bottom 65px
  h3
    padding 5px 0 5px 17px
    border-left 5px solid #2E7C80
    margin-bottom 25px
  table
    margin-bottom 60px
    th
      padding 8px 0
      text-align left
      font-weight normal
      vertical-align top
      &:first-child
        padding-right 20px
    td
      padding 8px 0
      vertical-align top
      span.require
        display inline-block
        color #CC0000
        padding 2px 5px
        border 1px solid #cc0000
        margin-right 20px
        font-size 12px
    ul
      display flex
      align-items center
      li
        margin-right 10px
    select
      width 90px
      background url("../../assets/ico_arrow_down.svg") no-repeat right 5px center
    label
      display inline-block
      overflow hidden
      position relative
    input[type="radio"]
      position absolute
      left -100px
    input[type="radio"] + span
      display inline-block
      width 16px
      height 16px
      border 1px solid #aaaaaa
      border-radius 50%
      vertical-align middle
      margin-top -2px
      margin-right 5px
      position relative
    input[type="radio"]:checked + span:after
      content ""
      display inline-block
      width 8px
      height 8px
      background-color #2E7C80
      border-radius 50%
      position absolute
      left 50%
      top 50%
      transform translate(-50%,-50%)
    textarea
      width 100%
      height 120px
  .submit-area
    display  flex
    justify-content center
    margin 0 auto 50px auto
  button,.back
    background-color #2E7C80
    font-size 20px
    font-weight bold
    color #ffffff
    border-radius 8px
    width 324px
    height 64px
    margin 0 10px
    display flex
    justify-content center
    align-items center
    text-decoration none
    cursor pointer
    &.back
      background-color #999999
      width 120px
    img
      vertical-align middle
      margin-left 10px
      display inline-block

</style>



// WEBPACK FOOTER //
// src/components/form/Index.vue